import { Inbox, Users, Clock, BarChart2 } from 'lucide-react';
import { SidebarItem } from './SidebarItem';
import { NotificationBell } from './NotificationBell';
import { TimerWidget } from './TimerWidget';
import type { ViewMode } from '@/types';

interface QuickAccessSectionProps {
  viewMode: ViewMode;
  stats?: {
    overdue: number;
    today: number;
    inProgress: number;
  };
  isLoading?: boolean;
  onViewModeChange: (mode: ViewMode) => void;
}

export function QuickAccessSection({ viewMode, stats, isLoading, onViewModeChange }: QuickAccessSectionProps) {
  return (
    <div className="px-3 pb-3 border-b border-border-primary">
      <div className="flex items-center justify-between mb-1">
        <span className="text-[10px] uppercase tracking-wider text-text-quaternary font-medium px-2.5">
          Accesso rapido
        </span>
        <div className="flex items-center gap-0.5">
          <TimerWidget />
          <NotificationBell />
        </div>
      </div>
      <div className="space-y-0.5">
        <SidebarItem
          icon={<Inbox className="w-4 h-4" />}
          label="Inbox"
          count={stats?.today}
          reserveCountSpace={true}
          isActive={viewMode === 'inbox'}
          isLoading={isLoading}
          onClick={() => onViewModeChange('inbox')}
          color="amber"
          overdueCount={stats?.overdue}
        />
        <SidebarItem
          icon={<Users className="w-4 h-4" />}
          label="Team"
          isActive={viewMode === 'team'}
          onClick={() => onViewModeChange('team')}
          color="blue"
        />
        <SidebarItem
          icon={<Clock className="w-4 h-4" />}
          label="Timesheet"
          isActive={viewMode === 'timesheet'}
          onClick={() => onViewModeChange('timesheet')}
          color="emerald"
        />
        <SidebarItem
          icon={<BarChart2 className="w-4 h-4" />}
          label="Report"
          isActive={viewMode === 'report'}
          onClick={() => onViewModeChange('report')}
          color="violet"
        />
      </div>
    </div>
  );
}
